import React, { Component } from "react";
import { fromJS } from 'immutable';
import CustomGrid from './custom-grid'
import TextInputField from '../../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../../infra/components/formInput/ComboboxInput'
import { InputTypeDropdown, InputTypeCombobox } from '../../../store/constants'

class CustomGridSearch extends Component{
    
    constructor(props){
        super(props)
        this.state = {
            search: fromJS({}),
            errors: fromJS({}), 
            showModal: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleChange(field, value) {
        console.log(field+"-"+value)
        var searchVal = this.state.search;
        searchVal = searchVal.set(field,value); 
        this.setState({ search:searchVal })
    }

    handleSelectChange(field) {
        var searchVal = this.state.search;
        // eslint-disable-next-line no-restricted-globals
        searchVal = searchVal.set(field,event.target.value); 
        this.setState({ search:searchVal })
    }
    
    handleSearch() {
        console.log(this.state.search);
        this.props.handleSearch(this.state.search);
    }

    handleOpenModal(){
        this.setState({ showModal: true })
    }

    handleClose(){
        this.setState({ showModal: false })
    }
    handleFormEntered(event){
        var code = event.keyCode || event.which;
        if(code === 13) { //13 is the enter keycode 
            this.handleSearch()
        }
    }
    populateSearchForm(item, search, errors){
        var inputType = item.get('inputType');
        var widthClass = item.get('widthClass')
        if(inputType === InputTypeDropdown){
            var items = item.get('data') != null ? item.get('data') : fromJS([]);
            var field = item.get('id');
            
            return(
                <div key={ item.get('id') } className="form-group no-margin-bottom">
                    <div className={widthClass}>
                        <b>
                            { item.get('label') }
                        </b>
                        <ComboboxInput
                            field={item.get('id')}
                            value={search.get( item.get('id') )}
                            options={fromJS({
                                'source': item.get('data'),
                                'value': 'value',
                                'label': 'label' , 
                            }) }
                            onChange={(field, value) => this.handleChange(field,value)}
                            placeholder={ item.get('placeholder') }
                        />
                        {/* <select className="form-control" 
                        style={ {'max-width': '100%'} } 
                        field={item.get('id')}
                        onChange={(e) => this.handleSelectChange(field)}
                        >
                            <option value="">select</option>
                            {
                                items.map((value) => {
                                    return(
                                    <option value={ value.get('value') } > { value.get('label') }</option>
                                    )
                                })
                            }
                        </select> */}
                    </div>
                </div>
            )
        }
        else if(inputType === InputTypeCombobox){
            var items = item.get('data') != null ? item.get('data') : fromJS([]);
            return(
                <div key={ item.get('id') } className="form-group no-margin-bottom">
                    <div className={widthClass}>
                        <b>
                        { item.get('label') }
                        </b>
                        <ComboboxInput
                            field={item.get('id')}
                            value={search.get( item.get('id') )}
                            options={fromJS({
                                'source': item.get('data'),
                                'value': 'value',
                                'label': 'label'  
                            }) }
                            onChange={(field, value) => this.handleChange(field,value)}
                            placeholder={item.get('placeholder')}
                        />
                    </div>
                </div>
            )
        }
        else{
            return(
                <div key={ item.get('id') } className="form-group no-margin-bottom">
                    <div className={widthClass}>
                        <b>
                            { item.get('label') }
                        </b>
                        <TextInputField className="form-control"
                            field={item.get('id')}
                            value={search.get( item.get('id') )}
                            onChange={(field, value) => this.handleChange(field,value)}
                            placeholder={ item.get('placeholder') }
                            hasError={errors.has('name')}
                        />
                    </div>
                </div>
            )
        }
    }

    populateButtonNew(){

        if(this.props.handleNew !== undefined && this.props.handleNew != null){
            if(this.props.panelHeader !== null && this.props.panelHeader !== undefined && this.props.panelHeader.size > 0){
                
                return this.props.panelHeader.map((item) => {
                    return(
                        <button type="button"
                                className={ item.get('classname') }
                                onClick={() => this.props.handleNew(item.get('id'))}>
                                <i className="material-icons">{item.get('icon')}</i> {item.get('title')}
                        </button> 
                    );
                })
                
            }else{
                var icons =  'add';
                var title = 'Add';
                if(this.props.buttonConfig !== undefined && this.props.buttonConfig != null){
                    var config = this.props.buttonConfig.get('new');
                    if(config != null){
                        icons = config.get('icon');
                        title = config.get('title');
                    }
                }
                
                return(
                    <button type="button"
                            className="btn btn-wide btn-success content-add"
                            value="Login"
                            onClick={this.props.handleNew}>
                            <i className="material-icons">{icons}</i> {title}
                    </button> 
                );
            }
        }  
    }

    populateCustomHeaderAction(){
        if(this.props.headerAction !== undefined){
            return this.props.headerAction.map((item) => {
                //debugger;
                return(
                    <button 
                        style={{ marginLeft:"6px" }}
                        type="button"
                        className="btn btn-wide btn-danger" 
                        onClick={() =>this.props.handleHeaderAction(item.get('id'))}>
                        <i className="material-icons">{item.get('icon')}</i> {item.get('title')}
                    </button> 
                )
            })
        }
    }

    render(){
        const { errors, search, showModal } = this.state
        return (
        <div className="clearfix">
            <div className="card" onKeyPress={(e) => this.handleFormEntered(e)}>
                <div className="body">
                    {   
                        // eslint-disable-nex       t-line array-callback-return
                        this.props.search.map((item) => {
                            return this.populateSearchForm(item, search, errors);
                        })  
                    }
                    <div className="form-group clearfix no-margin-bottom">
                        <div className="col-sm-12 no-margin-bottom">
                            <button type="button"
                                className="btn btn-wide btn-primary"
                                value="Login"
                                onClick={this.handleSearch}>
                                <i className="material-icons">search</i> Search
                            </button>
                        </div>
                    
                    </div>
                </div>
            </div>
            <div className="clearfix">
                    <div className="col-sm-12">
                    <div className="btn-group content-add" role="group">
                        { this.populateButtonNew() }
                        { this.populateCustomHeaderAction() }
                    </div>
                    </div>
                    </div>
            <div className="card">
                <div className="body">
                <div className="row">
                    <CustomGrid 
                        columns={ this.props.columns  } 
                        items={ this.props.items }  
                        handleOnBindCustomAction={this.props.handleOnBindCustomAction}
                        handleCustomAction={this.props.handleCustomAction}
                        handleViewClicked={this.props.handleViewClicked}
                        handleEditClicked={this.props.handleEditClicked}
                        handleRemoveClicked={this.props.handleRemoveClicked}
                        handlePageChanged={this.props.handlePageChanged}
                        sortForm={this.props.sortForm}
                        handleHeaderClicked={this.props.handleHeaderClicked}
                    >
                    </CustomGrid>
                </div>
                </div>
            </div>
        </div>
        );
    }
}

export default (CustomGridSearch);